import React from 'react'
import PropTypes from 'prop-types'
import { simpleStrDate } from 'utils/format'
import { ACTIVITY_TYPE } from 'constants/stock-activity'
import { DescItemList } from 'ui-components/DescItemList'
import { DescList } from 'ui-components/DescList'
import { Container } from './styles'

export default function StockActivity({ stockActivity }) {
  return (
    <DescList>
      <Container>
        <DescItemList label="Data">
          {simpleStrDate(stockActivity.attributes.date)}
        </DescItemList>
        <DescItemList label="Produto">
          {stockActivity.attributes.product.name}
        </DescItemList>
        <DescItemList label="Tipo">
          {ACTIVITY_TYPE[stockActivity.attributes.activity_type]}
        </DescItemList>
        <DescItemList label="Quantidade">
          {stockActivity.attributes.quantity}
        </DescItemList>
      </Container>
      <DescItemList label="Descrição">
        {stockActivity.attributes.description}
      </DescItemList>
    </DescList>
  )
}

StockActivity.propTypes = {
  stockActivity: PropTypes.objectOf(PropTypes.any).isRequired,
}
